import styled from "styled-components";

export const TeamUpdatedEntryContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
  padding: 8px;
  transition: all 0.2s ease;
`
export const LeftContent = styled.div`
    align-items: center;
    display: flex;
    gap: 16px;
`
export const DateDisplay = styled.h4`
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
    border-radius: 4px;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 600;
    padding: 8px 8px;
    text-align: center;
    width: 160px;
`
export const ActionDisplay = styled.h4`
    color: #FFFFFF;
    font-family: 'Inter', sans-serif;
    font-size: 12px;
`
export const TeamChangeDisplay = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;

    img {
        border-radius: 100px;
        height: 24px;
        width: 24px;
    }

    span {
        color: #FFFFFF;
    }
`